// mospina 10-10-16 EPT-2100 Versionamiento AVATAR
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'app_version_back';

@Injectable({ providedIn: 'root' })
export class VersionService {

  private readonly back = new BehaviorSubject<string>(this.leerGuardada());
  readonly back$ = this.back.asObservable();

  aplicar(back: any): void {
    const valor = this.limpiar(back);
    this.back.next(valor);
    try { localStorage.setItem(STORAGE_KEY, valor); } catch (e) { }
  }

  private leerGuardada(): string {
    try { return this.limpiar(localStorage.getItem(STORAGE_KEY)); } catch (e) { return ''; }
  }

  private limpiar(valor: any): string {
    return String(valor ?? '').trim().replace(/^v\s*/i, '');
  }
}
